export default "__VITE_ASSET__DhHcitOo__"